<div class="row">
    <!-- Section: FAQ -->
    <div class="col-lg-4">
        <div class="section-faq">
            <p class="faq-heading">Frequently Asked Questions</p>
            <p class="faq-description mt-3">Got questions? We’ve got answers! Check out our FAQ section for quick
                solutions to common inquiries. Whether you’re curious about our services, pricing, or anything else,
                we’re here to help!
            </p>
        </div>
    </div>

    <!-- Section: Expension Panel -->
    <div class="col-lg-8">
        <div class="row">
            <div *ngFor="let acc of accordions; let i = index" class="col-12 col-lg-6 gy-4">
                <div class="expension-panel">
                    <mat-accordion>
                        <mat-expansion-panel style="background-color: #3FA79B14;" (opened)="panelStates[i] = true" (closed)="panelStates[i] = false"
                            hideToggle>
                            <mat-expansion-panel-header style="background-color: #3FA79B14;">
                                <mat-panel-title>
                                    <div class="d-flex flex-row justify-content-between align-items-center w-100">
                                        <span [innerHTML]="acc.title"></span>
                                        <!-- Toggle icons -->
                                        <img *ngIf="!panelStates[i]" [src]="acc.expandImgSrc" alt="Expand" />
                                        <img *ngIf="panelStates[i]" [src]="acc.collapseImgSrc" alt="Collapse" />
                                    </div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="panel-body">
                                <hr class="mt-0">
                                <p style="color: #666666;" [innerHTML]="acc.description"></p>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
            </div>
        </div>
    </div>
</div>